import {useMutation, useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';

import {setAlert, setSuccessAlert} from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';

import playlistKeys from './queryKeys';
import {addPlaylistContent} from './useAddPlaylistAssets';

function useAddPlaylistLinks(playlistId) {
	const {t} = useTranslation();
	const queryClient = useQueryClient();
	const queryKey = playlistKeys.singlePlaylist(playlistId);

	const {mutateAsync, ...queryOptions} = useMutation(
		addPlaylistContent(playlistId),
		{
			onSuccess: (data, {content}) => {
				queryClient.invalidateQueries(queryKey);
				queryClient.invalidateQueries(contentKeys.contentLogs());
				setSuccessAlert({
					title: t('alert_playlist_added_successfully', {
						count: content.length,
					}),
				});
			},
			onError: (error, {content}) => {
				setAlert({
					title: t('alert_playlist_link_not_added', {
						count: content.length,
					}),
				});
			},
		}
	);

	return {
		...queryOptions,
		addPlaylistLinks: mutateAsync,
	};
}

export default useAddPlaylistLinks;
